import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api/client'
import type { CaseSummary } from '../api/types'
import { primeCaseIndex } from '../lib/case-index'

export function DoctorCases() {
  const [cases, setCases] = useState<CaseSummary[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    api.listCases()
      .then((r) => {
        const sorted = [...r.cases].sort((a, b) => {
          const aSmart = a.selection_kind === 'smart' ? 0 : 1
          const bSmart = b.selection_kind === 'smart' ? 0 : 1
          return aSmart - bSmart
        })
        setCases(sorted)
        primeCaseIndex(sorted)
      })
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-semibold mb-1 text-text">Doktor modu</h1>
      <p className="text-text-dim text-sm mb-2 max-w-3xl leading-relaxed">
        Bu liste, vakaları radyologların gördüğü çalışma listesine yakın bir
        biçimde sunar. Vakaların gerçek etiketi ve modelin tahmini gizlenir.
        Bir vaka seçtiğinizde lezyonun konumunu (3 boyutlu model ve kırmızı
        kaplama) görürsünüz, ancak iyi huylu mu yoksa kötü huylu mu olduğuna
        kendiniz karar vermeye çalışırsınız.
      </p>
      <p className="text-text-dim text-xs mb-6 max-w-3xl leading-relaxed">
        Standart galeri için{' '}
        <Link to="/cases" className="text-accent">Demo vakalar</Link>{' '}
        sayfasına dönebilirsiniz.
      </p>

      {loading && <p className="text-text-dim">Vakalar yükleniyor…</p>}
      {error && <p className="text-malignant">Hata: {error}</p>}
      {!loading && !error && (
        <div className="border border-border rounded overflow-hidden">
          <div className="hidden sm:grid grid-cols-[auto_1fr_auto_auto] gap-3 px-3 py-2 bg-surface text-text-dim text-[11px] uppercase tracking-wider border-b border-border">
            <span className="w-20">Vaka</span>
            <span>Kaynak</span>
            <span className="text-right">Hacim</span>
            <span className="w-6" aria-hidden="true" />
          </div>
          {cases.map((c, i) => (
            <DoctorRow key={c.id} c={c} number={i + 1} />
          ))}
        </div>
      )}
    </div>
  )
}

function DoctorRow({ c, number }: { c: CaseSummary; number: number }) {
  return (
    <Link
      to={`/cases/${encodeURIComponent(c.id)}?doctor=1`}
      className="grid grid-cols-[auto_1fr_auto_auto] gap-3 px-3 py-2.5 items-center bg-surface hover:bg-surface-2 border-b border-border last:border-b-0 no-underline"
    >
      <span className="w-20 text-text font-medium text-sm">Vaka #{number}</span>
      <span className="text-text-dim text-xs">
        <span className="inline-block px-1.5 py-0.5 rounded bg-surface-2 border border-border text-[10px] uppercase tracking-wider mr-2">
          {c.cohort}
        </span>
      </span>
      <span className="text-text-dim text-xs font-mono text-right whitespace-nowrap">
        {c.lesion_volume_ml.toFixed(2)} mL
      </span>
      <span className="text-text-dim text-sm">→</span>
    </Link>
  )
}
